import React from 'react';
import { Mail, Phone, MessageCircle } from 'lucide-react';
interface FooterProps {
  language: 'en' | 'es';
}
export function Footer({
  language
}: FooterProps) {
  const content = {
    en: {
      contact: 'Contact Us',
      legal: 'Legal Notice',
      helperBar: 'Need help? Chat live with an advisor now. (Se habla español)',
      businessOnly: 'Business funding only. Personal loans are not available.',
      disclaimer: 'CONFIDENTIALITY NOTICE: This communication and any attachments may contain confidential or privileged information for the use of the designated recipients. If you are not the intended recipient, you are hereby notified that you have received this communication in error and that any review, disclosure, dissemination, distribution or copying of it or its contents is prohibited. If you have received this communication in error, please notify the sender immediately and destroy all copies of this communication and any attachments.',
      copyright: '© 2025 Sparrow Advance LLC – All Rights Reserved.',
      trustSeals: 'SSL Secure • Norton Protected • Bank-Level Encryption'
    },
    es: {
      contact: 'Contáctenos',
      legal: 'Aviso Legal',
      helperBar: '¿Necesita ayuda? Chatee en vivo con un asesor ahora. (We speak English)',
      businessOnly: 'Solo financiamiento comercial. Préstamos personales no están disponibles.',
      disclaimer: 'AVISO DE CONFIDENCIALIDAD: Esta comunicación y cualquier archivo adjunto pueden contener información confidencial o privilegiada para uso de los destinatarios designados. Si usted no es el destinatario previsto, se le notifica que ha recibido esta comunicación por error y que cualquier revisión, divulgación, difusión, distribución o copia de la misma o de su contenido está prohibida. Si ha recibido esta comunicación por error, notifique al remitente de inmediato y destruya todas las copias de esta comunicación y cualquier archivo adjunto.',
      copyright: '© 2025 Sparrow Advance LLC – Todos los Derechos Reservados.',
      trustSeals: 'SSL Seguro • Protegido por Norton • Encriptación de Nivel Bancario'
    }
  };
  const t = content[language];
  return <>
      <div className="w-full bg-gradient-to-r from-[#2D5D9F] to-[#142B44] text-white py-4" data-id="element-56">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-center space-x-3" data-id="element-57">
          <MessageCircle size={20} data-id="element-58" />
          <span className="text-sm font-medium" data-id="element-59">{t.helperBar}</span>
        </div>
      </div>
      <footer className="w-full bg-[#142B44] text-white py-12" data-id="element-60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-61">
          <div className="text-center mb-8" data-id="element-62">
            <p className="text-lg font-bold text-yellow-300" data-id="element-63">
              {t.businessOnly}
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8" data-id="element-64">
            <div data-id="element-65">
              <h3 className="text-xl font-bold mb-4" data-id="element-66">{t.contact}</h3>
              <div className="space-y-3" data-id="element-67">
                <div className="flex items-center space-x-3" data-id="element-68">
                  <Mail size={20} data-id="element-69" />
                  <a href="mailto:Antony@sparrowadvance.com" className="hover:text-[#2D5D9F] transition-colors" data-id="element-70">
                    Antony@sparrowadvance.com
                  </a>
                </div>
                <div className="flex items-center space-x-3" data-id="element-71">
                  <Phone size={20} data-id="element-72" />
                  <a href="tel:+13058138377" className="hover:text-[#2D5D9F] transition-colors" data-id="element-73">
                    (305) 813-8377
                  </a>
                </div>
              </div>
            </div>
            <div data-id="element-74">
              <h3 className="text-xl font-bold mb-4" data-id="element-75">{t.legal}</h3>
              <p className="text-sm text-gray-300 leading-relaxed mb-4" data-id="element-76">
                {t.disclaimer}
              </p>
              <p className="text-xs text-gray-400" data-id="element-77">{t.trustSeals}</p>
            </div>
          </div>
          <div className="border-t border-gray-700 pt-8 text-center" data-id="element-78">
            <p className="text-sm text-gray-400" data-id="element-79">{t.copyright}</p>
          </div>
        </div>
      </footer>
    </>;
}